import axios from 'axios'
import {getApiUrl} from '../Services/helpers.jsx'
import store from './store.jsx'

export const auth = (state, token) => {
  state.token = token
  return state
}

export const setWordCount = (state, count) => {
  count = Number(String(count).replace(/[^\d]/g, '')) || 0 // no NaN or empty  values
  state.wordCount = count
  state.wordCountTouched = true
  return state
}

export const showUploader = (state, uploaderIsVisible) => {
  state.uploaderIsVisible = uploaderIsVisible
  return state
}

export const addFile = (state, binary, wordCountEnabled = false) => {
  const files = [...state.files]

  // don't add same file twice
  if (files.find((f) => f.name === binary.name)) return state

  // don't add 0 byte files
  // if (!binary.size)
  //     return state;

  const file = {
    name: binary.name,
    size: binary.size,
    type: binary.type,
    uploading: true,
    fromContactForm: false,
    countEnabled: wordCountEnabled,
    count: 0,
    countTouched: false,
    text: '',
    url: '',
    uploadFailed: false,
    countFailed: false,
  }

  state.files = [...state.files, file]
  return state
}

export const uploadFile = async (
  state,
  binary,
  wordCountEnabled,
  fromContactForm = false,
) => {
  const {files} = state
  // tofix: this is crap
  const source = document.querySelector('input[name=source-hidden]')
    ? document.querySelector('input[name=source-hidden]').value
    : null
  const target = document.querySelector('input[name=target-hidden]')
    ? document.querySelector('input[name=target-hidden]').value
    : null

  const file = files.find((f) => f.name === binary.name)

  // if (!binary.size)
  //     return state;

  if (!file) {
    console.error('file not found before uploading?')
    return state
  }

  file.fromContactForm = fromContactForm

  const formData = new FormData()
  formData.append('source', source)
  formData.append('target', target)
  formData.append('count', Number(wordCountEnabled)) //only text values in formData!
  formData.append(
    'content',
    wordCountEnabled && process.env.NODE_ENV !== 'production',
  )
  formData.append('folder', fromContactForm ? 'website-form' : 'website-quotes')
  formData.append('file', binary)

  try {
    const {data} = await axios.post(
      getApiUrl() + '/file/upload',
      formData,
    )
    file.url = data.url
    file.count = data.count || 0 //if count fails, no count is returned but we need a default value
    file.text = data.text

    if (data.url) file.countFailed = data.error
    else file.uploadFailed = data.error
  } catch (error) {
    console.error(error)
    file.uploadFailed = error.message
  } finally {
    file.uploading = false
  }

  // array of files may be changed since we started processing this file!
  // discard stale state and get the latest one
  const latestState = store.getState()

  latestState.files = [...latestState.files] // trigger re-render of files array loosing previous reference
  const latestFile = latestState.files.find((f) => f.name === binary.name)
  if (latestFile) Object.assign(latestFile, file)
  else
    console.warn(
      file.name + ' was removed before setting upload result on file object',
    )

  return updateWordCount(latestState)
}

export const removeFile = (state, name) => {
  state.files = state.files.filter((file) => file.name !== name)
  return updateWordCount(state)
}

export const removeFiles = (
  state,
  fromContactForm = undefined,
  shouldUpdateWordCount = true,
) => {
  if (fromContactForm === true)
    state.files = state.files.filter((file) => file.fromContactForm !== true)
  else if (fromContactForm === false)
    state.files = state.files.filter((file) => file.fromContactForm !== false)
  else state.files = []

  if (!shouldUpdateWordCount) return updateWordCount(state)
  else return state
}

export const setFileCount = (state, fileName, count) => {
  count = Number(String(count).replace(/[^\d]/g, '')) || 0 // no NaN or empty  values

  const files = [...state.files]
  const file = files.find((file) => file.name === fileName)
  if (file) {
    file.count = count
    file.countTouched = true // user touched wordcount from uploder modal for this file
  } else console.warn(fileName + ' was removed before executing setFileCount')
  state.files = files

  return updateWordCount(state)
}

export const updateWordCount = (state) => {
  const files = state.files
  state.wordCount =
    files
      .filter((file) => !file.uploading && !file.uploadFailed)
      .map((file) => file.count)
      .reduce((a, b) => a + b, 0) || 1000 // default is 1000 words
  state.wordCountTouched = false
  return state
}
